/**
 * ProfileButton - Report Scents button (no login required)
 */

import { cn } from '@/utils/cn';

interface ProfileButtonProps {
  onLoginClick?: () => void; // Optional, kept for compatibility
  onSocialClick: () => void;
}

export function ProfileButton({ onSocialClick }: ProfileButtonProps) {
  // Always open Social Panel directly - no login required
  return (
    <button
      onClick={onSocialClick}
      className={cn(
        'flex items-center gap-2 px-3 py-2 rounded-lg',
        'bg-slate-900/80 backdrop-blur-md',
        'border border-slate-700/50',
        'text-slate-300 text-sm font-medium',
        'shadow-lg',
        'hover:bg-slate-800/80 transition-colors',
        'active:scale-95'
      )}
    >
      <ScentIcon className="w-4 h-4" />
      <span>Report Scents</span>
    </button>
  );
}

// Scent/smell icon
function ScentIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
    </svg>
  );
}
